// src/components/ResourceManager/Hardware/HardwareTableColumns.ts

import React from "react";
import { GenericTableColumn } from "@ui-components/Table/GenericTable";
import { Customer } from "../request/request";


// Icons
import { ReactComponent as IconEye } from "../../../../../shared/assets/Icons/Icon_Eye.svg";
import { ReactComponent as IconEdit } from "../../../../../shared/assets/Icons/Icon_Edit.svg";
import { ReactComponent as IconDelete } from "../../../../../shared/assets/Icons/Icon_Delete.svg";

/**
 * Props que recibe getHardwareColumns para definir las acciones.
 */
interface CustomerColumnsProps {
    handleViewCustomer: (hw: Customer) => void;
    handleEditCustomer: (hw: Customer) => void;
    handleDeleteClick: (hw: Customer) => void;
}

/**
 * Retorna las columnas de la tabla para Hardware.
 */
export function getCustomerColumns({
    handleViewCustomer,
    handleEditCustomer,
    handleDeleteClick,
}: CustomerColumnsProps): GenericTableColumn<Customer>[] {
    return [
        {
            header: "ID",
            accessor: "id",
        },
        {
            header: "Customer Name",
            accessor: "displayName",
        },
        {
            header: "Domain",
            accessor: "domain",
        },
        {
            header: "Product list",
            accessor: "productList",
        },
        {
            header: "Actions",
            accessor: "id",
            renderCell: (row) => (
                <div className="flex items-center gap-2">
                    {/* View */}
                    <button
                        className="
              flex items-center justify-center
              border border-semantic-border-secondary
              rounded
              text-semantic-text-secondary
              hover:bg-semantic-state-active
              w-10 h-10
            "
                        onClick={() => handleViewCustomer(row)}
                    >
                        <IconEye className="w-6 h-6" />
                    </button>

                    {/* Edit */}
                    <button
                        className="
              flex items-center justify-center
              border border-semantic-border-secondary
              rounded
              text-semantic-text-secondary
              hover:bg-semantic-state-active
              w-10 h-10
            "
                        onClick={() => handleEditCustomer(row)}
                    >
                        <IconEdit className="w-10 h-10" />
                    </button>

                    {/* Delete */}
                    <button
                        className="
              p-2
              border border-semantic-border-secondary
              rounded
              bg-red-50
              text-red-600
              hover:bg-red-100
            "
                        onClick={() => handleDeleteClick(row)}
                    >
                        <IconDelete className="w-6 h-6" />
                    </button>
                </div>
            ),
        },
    ];
}
